/// <reference path="../../base/api.js" />
/// <reference path="../../global/fn.js" />


(function ($) {

	$.widget("nsp.inViewport", {
		options: {
			offset:100,
			cls: "onScreen"
		},
		_create: function () {
			var plgn = this;
			var section = plgn.element;

			$(document).on("window-loaded", ()=> {
				plgn.isOnScreen();
			})
			plgn.isOnScreen();

			plgn.scrolling = false;
			plgn.scrolltimer = 0;
			$(window).on('scroll', function () {
				plgn.scrolling = true;
				clearTimeout(plgn.scrolltimer);
				scrolltimer = setTimeout(function () {
					plgn.isOnScreen();
				}, 300);
			});

			$(window).on('resize', function () {
				setTimeout(function () {
					plgn.isOnScreen();
				}, 300);
			});

		},
		isOnScreen: function () {
			var plgn = this;
			var section = plgn.element;

			var win = $(window);

			section.onScreenCls = !section.onScreenCls ? plgn.options.cls : section.onScreenCls;


			var viewport = {
				top: win.scrollTop(),
				left: win.scrollLeft()
			};
			viewport.right = viewport.left + win.width();
			viewport.bottom = viewport.top + win.height();

			var bounds = section.offset();
			bounds.right = bounds.left + section.outerWidth();
			bounds.bottom = bounds.top + section.outerHeight();

			var headeroffset = 0;
			if ($('.header__outer').length) {
				headeroffset = $('.header__outer').outerHeight();
			}

			var offset = headeroffset + plgn.options.offset;


			if (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top + offset || viewport.top > bounds.bottom - offset)) {
				section.addClass(section.onScreenCls);
				section.addClass("onScreenOnce");

				plgn._trigger('onScreen', null, { item: section });

			} else {
				section.removeClass(section.onScreenCls);

				plgn._trigger('offScreen', null, { item: section });
			}


		}
	});


})(jQuery);